import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  return (
    <footer>
      <div className="container inner">
        <div className="footer-top">
          <div
            className={`get-started bg-danger footer-top-item ${
              location.pathname === "/login" ||
              location.pathname === "/register"
                ? "d-none"
                : ""
            }`}
          >
            <h2>CLICK TO GET STARTED</h2>
            <p>
              If you join today, you can already get returns tomorrow. Start
              line begins at our quick and easy registration page.
            </p>
            <Link to="/register">
              <button className="btn">SIGN-UP TODAY</button>
            </Link>{" "}
          </div>
          <div
            className={`more-questions bg-secondary footer-top-item ${
              location.pathname === "/faq" ? "d-none" : ""
            }`}
          >
            <h2>HAVE MORE QUESTIONS?</h2>
            <p>
              Feel free to seek your answer in our frequently asked questions
              page, or write to our support staff.
            </p>

            <Link to="/faq">
              <button className="btn">CONTACT &amp; FAQ</button>
            </Link>
          </div>
        </div>

        <div className="main-footer">
          <div className="footer-about">
            <Link to="#">
              <img src="/imgs/logofull.png" alt="" />
            </Link>
            <small>Kuxtech, LTD</small>
            <small>Incorporation #12290383</small>

            <i>
              <small>All Rights Reserved, Kuxtech &copy; 2023</small>
            </i>

            <hr />

            <div className="payment-icons">
              <i className="fab fa-bitcoin text-primary"></i>
              <i className="fab fa-cc-mastercard"></i>
              <i className="fab fa-cc-visa"></i>
              <i className="fab fa-cc-paypal text-danger"></i>
            </div>
          </div>

          <div className="footer-links">
            <ul>
              <li>
                <h6>SECURITY</h6>
                <p>DDoS Protection</p>
                <p>OPERATIONAL</p>
                <p>EV SSL Encryption</p>
              </li>
              <li>
                <h6>SERVICE</h6>
                <p>Loan Plan</p>
                <p>How it Works</p>
                <p>About Us</p>
              </li>
              <li>
                <h6>CONTACT</h6>
                <p>Contact Us</p>
                <p>Telegram</p>
                <p>FAQ Page</p>
              </li>
              <li>
                <h6>LEGAL</h6>
                <p>Terms of Use</p>
                <p>ID Insurance</p>
                <p>Company Cert</p>
              </li>
            </ul>
            <small className="text-light">
              Use of Kuxtech's Services are subject to this <i>terms of use</i>.
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
